export const config = {
    apiUrl: "/api/v1/saas"
}